module.exports = __webpack_public_path__ + "img/bg5.09ff006f.png";